document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[js-main-product]').forEach(initMainProduct);
});

function initMainProduct(section) {
  const options = section.querySelectorAll('[js-variant-option]');
  const priceEl = section.querySelector('[js-variant-price]');
  const variantInput = section.querySelector('[js-variant-id]');
  const form = section.querySelector('[js-main-product-form]');
  const atcBtn = section.querySelector('[js-main-product-atc]');
  const atcText = section.querySelector('[js-atc-text]');
  const notifyBtn = section.querySelector('[js-main-product-notify]');
  const defaultText = atcText ? atcText.innerHTML : '';

  options.forEach(option => {
    option.addEventListener('click', (e) => {
      e.preventDefault();

      options.forEach(item => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-checked', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-checked', 'true');

      const available = option.getAttribute('data-variant-available') === 'true';

      if (priceEl) {
        priceEl.innerHTML = option.getAttribute('data-variant-price');
      }

      if (variantInput) {
        variantInput.value = option.getAttribute('data-variant-id');
      }

      if (atcBtn) {
        atcBtn.disabled = !available;
        if (atcText) {
          atcText.innerHTML = available ? defaultText : (window.variantStrings ? window.variantStrings.soldOut : 'Sold out');
        }
      }

      // Back-in-stock button (reads the variant from the form's id input).
      if (notifyBtn) notifyBtn.hidden = available;
    });
  });

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const variantId = variantInput ? Number(variantInput.value) : -1;
      if (variantId === -1 || atcBtn.disabled) return;

      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(response => response.json())
        .then(() => updateCartCount())
        .catch(error => console.error('Error adding to cart:', error))
        .then(() => {
          atcBtn.disabled = false;
        });
    });
  }
}

function updateCartCount() {
  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
    .then(res => res.json())
    .then(cart => {
      const cartNum = document.querySelector('[js-cart-num]');
      if (cartNum) {
        cartNum.innerHTML = cart.item_count;
      }
    });
}
